import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedIncomingPort = mutatorAction('updateAdvancedIncomingPort', function (incomingPort) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.incomingPort = incomingPort;
});
//# sourceMappingURL=updateAdvancedIncomingPort.js.map